import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {VersioningService} from 'app/fragment/versioning/versioning.service';
import {AbstractSectionResolver} from 'app/routing/resolvers/abstract-section-resolver';
import {DocumentService} from 'app/services/document.service';
import {SectionService} from 'app/services/section.service';
import {ViewMode} from 'app/view/current-view';
import {CurrentLocation, ViewService} from 'app/view/view.service';

@Injectable({
  providedIn: 'root',
})
export class SectionExportResolverService extends AbstractSectionResolver {
  protected breadcrumb: string = 'export';
  protected routeName: string = 'Print Preview';
  protected viewMode: ViewMode = ViewMode.EXPORT;
  protected location: CurrentLocation = CurrentLocation.PRINT_PREVIEW;

  constructor(
    protected documentService: DocumentService,
    protected sectionService: SectionService,
    protected versioningService: VersioningService,
    protected viewService: ViewService,
    protected snackBar: MatSnackBar,
    protected router: Router
  ) {
    super(documentService, sectionService, versioningService, viewService, snackBar, router);
  }
}
